import { render } from "./ItemRow.vue?vue&type=template&id=3a274896&scoped=true"
import script from "./ItemRow.vue?vue&type=script&lang=js"
export * from "./ItemRow.vue?vue&type=script&lang=js"

import "./ItemRow.vue?vue&type=style&index=0&id=3a274896&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a274896"]])

export default __exports__